import { render, staticRenderFns } from "./rpterpreenrollbyinst.vue?vue&type=template&id=65c4c6a2&"
import script from "./rpterpreenrollbyinst.vue?vue&type=script&lang=js&"
export * from "./rpterpreenrollbyinst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports